import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { DriverTypeService } from '../../../core/services/doctor/driver-type/driver-type.service'

@Component({
  selector: 'health-agent-type-edit',
  imports: [
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    MatFormField,
    MatInput,
    MatLabel,
  ],
  templateUrl: './doctor-type-edit.component.html',
  styleUrl: './doctor-type-edit.component.scss',
  providers: [DriverTypeService],
  standalone: true,
})
export class DoctorTypeEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private driverTypeService: DriverTypeService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<DoctorTypeEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.itemEdit = data
  }

  @Output() responseEdit = new EventEmitter()

  itemEdit: any = {}
  form: FormGroup = new FormGroup({})
  loading: boolean = false

  ngOnInit(): void {
    this.createForm()
  }

  updateItem() {
    this.loading = true
    const model = this.createModel()
    this.driverTypeService.editDriverType(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      id: this.itemEdit.id,
      descricao: this.form.controls['description'].value,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      code: [this.itemEdit.id, [Validators.required]],
      description: [this.itemEdit.descricao, [Validators.required]],
    })
    this.form.get('code')?.disable()
  }
}
